import { MemberType } from '@aibees/shared/definition';
import { BillingProfile } from '@aibees/shared/features/billing-profile';
import { BillingInformation } from '@aibees/shared/features/billing-profile/components/billing-information';
import { InvoiceTable } from '@aibees/shared/features/billing-profile/components/invoice-table';
import { PaymentMethods } from '@aibees/shared/features/billing-profile/components/payment-methods';
import { useCheckIsB2BEnrichment } from '@aibees/shared/hooks';
import { useRedirect } from '@aibees/shared/router';
import { useGetUserRole } from '@aibees/shared/workspace';

export function BillingView() {
  const redirect = useRedirect();
  const isEnrichment = useCheckIsB2BEnrichment();
  const role = useGetUserRole();
  if (role === MemberType.User && !isEnrichment) redirect('/');

  return (
    <BillingProfile
      config={[
        {
          title: 'Payment Methods',
          isActive: true,
          component: <PaymentMethods />,
        },
        {
          title: 'Billing Information',
          isActive: false,
          component: <BillingInformation />,
        },
        {
          title: 'Billing History',
          isActive: false,
          component: <InvoiceTable />,
        },
      ]}
    />
  );
}
